
<template>
  <div id="init-home-container" class="mt-3 d-flex" style="width: 100%">
    <auth></auth>

    <v-spacer></v-spacer>
    <v-main>
      <v-container class="whitesmoke black--text" id="home-container" style="max-width: 768px">
        <v-btn
          @click="go_admin"
          style="margin-bottom: 10px"
          color="#002e42"
          class="white--text"
          v-if="admin"
        >
          ADMIN
        </v-btn>

        <h4 class="whitesmoke black--text">
          Please complete this Narcan Use form.
        </h4>

        <v-form ref="form" lazy-validation v-model="valid">
          <v-container>

            <!-- Name + Badge -->
             <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                  v-model="narcan.email"
                  label="Your Email:"
                  maxlength="60"
                  readonly
                ></v-text-field>
              </v-col>
             </v-row>
            <v-row>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="narcan.first_name"
                  label="First Name:"
                  :rules="requiredAlways"
                  required
                  maxlength="60"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="narcan.last_name"
                  label="Last Name:"
                  :rules="requiredAlways"
                  required
                  maxlength="60"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="narcan.badge_number"
                  label="Badge #:"
                  :rules="requiredAlways"
                  required
                  maxlength="20"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Date + Case Number -->
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="narcan.narcan_date"
                  label="Date of Narcan Use:"
                  required
                  :rules="requiredAlways"
                  v-mask="'##/##/####'"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="narcan.case_number"
                  label="Case Number / Call Number where Narcan was used:"
                  required
                  :rules="requiredAlways"
                  maxlength="12"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Used on: select -->
            <v-row>
              <v-col cols="12" md="6">
                <label for="used_on">Was the Narcan used on a citizen or officer?</label>
                <v-select
                  label=""
                  id="used_on"
                  v-model="narcan.used_on"
                  :items="used_on_items"
                  attach
                  solo
                  :menu-props="{ bottom: true, offsetY: true }"
                  :rules="requiredAlways"
                  required
                ></v-select>
              </v-col>
            </v-row>

            <!-- Submit -->
            <v-row>
              <v-col cols="12" md="4">
                <v-btn @click="save" class="black white--text">Submit</v-btn>
              </v-col>
            </v-row>

          </v-container>
        </v-form>
      </v-container>
    </v-main>
    <v-spacer></v-spacer>
  </div>
</template>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import auth from "./auth.vue";

export default {
  name: "NarcanUse",
  components: { auth },
  mixins: [bus_common],
  data() {
    return {
      valid: false,

      used_on_items: ["Officer / RPD Civilian", "Citizen"],

      // if you like having a dev seed
      new_narcan_dev: {
        email:"",
        first_name: "Bob",
        last_name: "Smith",
        badge_number: "R-1234567",
        narcan_date: "",
        case_number: "11-11111",
        used_on: "Citizen",
      },

      new_narcan: {        
          email:"",
        first_name: "",
        last_name: "",
        badge_number: "",
        narcan_date: "",
        case_number: "",
        used_on: "",},

      narcan: {
          email:"",
        first_name: "",
        last_name: "",
        badge_number: "",
        narcan_date: "",
        case_number: "",
        used_on: "",
      },

      // simple always-required rule set
      requiredAlways: [(v) => !!v || "Required"],
    };
  },
  computed: {
    admin: function () {
      return this.$store.state.user.roles.indexOf("pubcom-admin") > -1;
    },
    youremail: function(){
        return this.$store.state.user.email;
    }
  },
  watch: {
  '$store.state.user.email': function (val) {
    if (val) this.narcan.email = val;
  }
},
  methods: {
    go_admin() {
      this.$router.push("/admin");
    },

    save() {
      if (!this.$refs.form.validate()) {
        this.swall_it(
          "Submit Status",
          "Please attend to the Fields marked in red.",
          "warning",
          null,
          null
        );
        return true;
      }

      let self = this;
      self.show_loader(true);

      let formIn = {};
      formIn.apiname = "save_narcan"; // placeholder; you'll map later

      // payload
      formIn.narcan = this.narcan;

      // date normalization like your pattern
      formIn.narcan.narcan_date = this.format_date_sql(this.narcan.narcan_date);

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);
          self.mrbreakpoint();
          self.swall_it(
            "Save Status",
            "Your submission has been recorded.",
            "success",
            null,
            null
          );
          self.$refs.form.reset();
          self.narcan = self.mno(self.new_narcan);
          self.init();
          this.$nextTick(() => {
            self.narcan.narcan_date = self.format_date_us(new Date());
          });
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg, "error", null, null);
        });
    },

    init() {
      this.show_loader(false);
      this.narcan = this.mno(this.new_narcan); // or new_narcan
      this.narcan.narcan_date = this.format_date_us(new Date());
      this.narcan.email = this.youremail;
      this.new_narcan_dev.email = this.youremail;
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      self.init();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    width: 100vw;
    max-width: 100vw;
    height: auto;
  }

  .results .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap,
  .recent .v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
    padding: 0 7px !important;
  }

  .alice {
    color: aliceblue;
  }
}

/* 768 media q *
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>